import { useNavigate } from 'react-router-dom';
import type { WidgetProps } from './registry';
import { decodeWidgetData } from './decode-widget-data';

type Thread = { prospectId: string; handle?: string; lastMessageAt?: string; snippet?: string };

// H.2.4: /outreach/prospects/:id retired — prospect links now scope the chat.
function ProspectBtn({ prospectId, label }: { prospectId: string; label: string }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="text-sm font-medium hover:underline text-left"
      onClick={() => {
        sessionStorage.setItem('outreach-scope', JSON.stringify({ prospectId }));
        navigate('/outreach');
      }}
    >
      {label}
    </button>
  );
}

export function ConversationsList(props: WidgetProps) {
  const threads = (decodeWidgetData(props.payload).threads ?? []) as Thread[];

  if (threads.length === 0) {
    return <p className="text-sm text-foreground-mute">No conversations yet.</p>;
  }

  return (
    <ul className="space-y-2">
      {threads.map((t) => (
        <li key={t.prospectId} className="rounded border border-border p-2">
          <ProspectBtn
            prospectId={t.prospectId}
            label={t.handle ? `@${t.handle}` : t.prospectId}
          />
          {t.lastMessageAt && <p className="text-[10px] text-foreground-mute mt-1">{t.lastMessageAt}</p>}
          {t.snippet && <p className="text-xs text-foreground-mute mt-1 truncate">{t.snippet}</p>}
        </li>
      ))}
    </ul>
  );
}
